module.exports = __webpack_public_path__ + "media/images/icons/spinner-white-fe6f38f3cd2c850de9644ca7a646bb2c.svg";